import { render, staticRenderFns } from "./dashboardIcon.vue?vue&type=template&id=b0fb719e&"
import script from "./dashboardIcon.vue?vue&type=script&lang=js&"
export * from "./dashboardIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports